import React, { useRef, useEffect, useState, forwardRef } from 'react';
import classnames from 'classnames';

const Alert = _ref => {
  let {
    size = "md",
    text,
    theme = "default"
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("alert", `${size}-alert`, `${theme}-alert`),
    role: "alert"
  }, text);
};

const BadgeWrapper = _ref => {
  let {
    size,
    theme,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    className: classnames("badge", `${theme}-badge`, `${size}-badge`)
  }, children);
};

const FeaturedBadgeIcon = _ref => {
  let {
    iconSize = 16
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    className: "d-if ai-c jc-c mr-4p"
  }, /*#__PURE__*/React.createElement("svg", {
    role: "img",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: iconSize,
    height: iconSize,
    viewBox: "0 0 16 16",
    className: "featured-badge__icon",
    style: {
      fill: "currentcolor"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 .5 2.472 4.937L16 6.23l-4 3.843.944 5.427L8 12.937 3.056 15.5 4 10.073 0 6.229l5.528-.793L8 .5Z"
  })));
};
const Featured = _ref2 => {
  let {
    size = "md"
  } = _ref2;
  return /*#__PURE__*/React.createElement(BadgeWrapper, {
    size: size,
    theme: "featured"
  }, /*#__PURE__*/React.createElement(FeaturedBadgeIcon, {
    iconSize: size === "sm" ? 10 : 14
  }), "Featured");
};
Featured.displayName = "Badge.Featured";

const Badge = _ref => {
  let {
    size = "md",
    text,
    theme = "default"
  } = _ref;
  return /*#__PURE__*/React.createElement(BadgeWrapper, {
    size: size,
    theme: theme
  }, text);
};
Badge.Featured = Featured;

const Button = _ref => {
  let {
    disabled = false,
    isLoading = false,
    onClick = undefined,
    size = "lg",
    text,
    theme = "primary",
    type = "button",
    variant = "filled"
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    type: type,
    className: classnames("btn", `${size}-btn`, `${variant}-btn`, `${theme}-btn`, isLoading && "loading-btn"),
    disabled: disabled || isLoading,
    onClick: onClick
  }, isLoading && /*#__PURE__*/React.createElement("span", {
    className: "spinner"
  }), text);
};

const Checkbox = _ref => {
  let {
    checked,
    disabled = false,
    id,
    onChange = undefined,
    size = "md",
    label
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-f p-r"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: id,
    className: classnames("checkbox", size === "lg" && "large-checkbox"),
    checked: checked,
    disabled: disabled,
    onChange: event => {
      onChange && onChange(event);
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: classnames("checkbox-label", size === "lg" && "large-checkbox-label")
  }, label));
};

const classes$2 = {
  base: {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
    6: "grid-cols-6"
  },
  xs: {
    1: "xs:grid-cols-1",
    2: "xs:grid-cols-2",
    3: "xs:grid-cols-3",
    4: "xs:grid-cols-4",
    5: "xs:grid-cols-5",
    6: "xs:grid-cols-6"
  },
  sm: {
    1: "sm:grid-cols-1",
    2: "sm:grid-cols-2",
    3: "sm:grid-cols-3",
    4: "sm:grid-cols-4",
    5: "sm:grid-cols-5",
    6: "sm:grid-cols-6"
  },
  md: {
    1: "md:grid-cols-1",
    2: "md:grid-cols-2",
    3: "md:grid-cols-3",
    4: "md:grid-cols-4",
    5: "md:grid-cols-5",
    6: "md:grid-cols-6"
  },
  lg: {
    1: "lg:grid-cols-1",
    2: "lg:grid-cols-2",
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
    5: "lg:grid-cols-5",
    6: "lg:grid-cols-6"
  },
  xl: {
    1: "xl:grid-cols-1",
    2: "xl:grid-cols-2",
    3: "xl:grid-cols-3",
    4: "xl:grid-cols-4",
    5: "xl:grid-cols-5",
    6: "xl:grid-cols-6"
  }
};
function getColumnClasses(columns) {
  const hasColumnBreakpoints = Array.isArray(columns);
  const baseColumnValue = hasColumnBreakpoints ? columns[0] : columns;
  const columnBpValues = hasColumnBreakpoints ? columns[1] : undefined;
  return [classes$2.base[baseColumnValue], (columnBpValues === null || columnBpValues === void 0 ? void 0 : columnBpValues.xs) && classes$2.xs[columnBpValues.xs], (columnBpValues === null || columnBpValues === void 0 ? void 0 : columnBpValues.sm) && classes$2.sm[columnBpValues.sm], (columnBpValues === null || columnBpValues === void 0 ? void 0 : columnBpValues.md) && classes$2.md[columnBpValues.md], (columnBpValues === null || columnBpValues === void 0 ? void 0 : columnBpValues.lg) && classes$2.lg[columnBpValues.lg], (columnBpValues === null || columnBpValues === void 0 ? void 0 : columnBpValues.xl) && classes$2.xl[columnBpValues.xl]];
}

const classes$1 = {
  base: {
    0.25: "gap-0.25",
    0.5: "gap-0.5",
    1: "gap-1",
    2: "gap-2",
    3: "gap-3",
    4: "gap-4",
    5: "gap-5",
    6: "gap-6",
    7: "gap-7",
    8: "gap-8"
  },
  xs: {
    0.25: "xs:gap-0.25",
    0.5: "xs:gap-0.5",
    1: "xs:gap-1",
    2: "xs:gap-2",
    3: "xs:gap-3",
    4: "xs:gap-4",
    5: "xs:gap-5",
    6: "xs:gap-6",
    7: "xs:gap-7",
    8: "xs:gap-8"
  },
  sm: {
    0.25: "sm:gap-0.25",
    0.5: "sm:gap-0.5",
    1: "sm:gap-1",
    2: "sm:gap-2",
    3: "sm:gap-3",
    4: "sm:gap-4",
    5: "sm:gap-5",
    6: "sm:gap-6",
    7: "sm:gap-7",
    8: "sm:gap-8"
  },
  md: {
    0.25: "md:gap-0.25",
    0.5: "md:gap-0.5",
    1: "md:gap-1",
    2: "md:gap-2",
    3: "md:gap-3",
    4: "md:gap-4",
    5: "md:gap-5",
    6: "md:gap-6",
    7: "md:gap-7",
    8: "md:gap-8"
  },
  lg: {
    0.25: "lg:gap-0.25",
    0.5: "lg:gap-0.5",
    1: "lg:gap-1",
    2: "lg:gap-2",
    3: "lg:gap-3",
    4: "lg:gap-4",
    5: "lg:gap-5",
    6: "lg:gap-6",
    7: "lg:gap-7",
    8: "lg:gap-8"
  },
  xl: {
    0.25: "xl:gap-0.25",
    0.5: "xl:gap-0.5",
    1: "xl:gap-1",
    2: "xl:gap-2",
    3: "xl:gap-3",
    4: "xl:gap-4",
    5: "xl:gap-5",
    6: "xl:gap-6",
    7: "xl:gap-7",
    8: "xl:gap-8"
  }
};
function getGapClasses(gap) {
  const hasGapBreakpoints = Array.isArray(gap);
  const baseGapValue = hasGapBreakpoints ? gap[0] : gap;
  const gapBpValues = hasGapBreakpoints ? gap[1] : undefined;
  return [baseGapValue && classes$1.base[baseGapValue], (gapBpValues === null || gapBpValues === void 0 ? void 0 : gapBpValues.xs) && classes$1.xs[gapBpValues.xs], (gapBpValues === null || gapBpValues === void 0 ? void 0 : gapBpValues.sm) && classes$1.sm[gapBpValues.sm], (gapBpValues === null || gapBpValues === void 0 ? void 0 : gapBpValues.md) && classes$1.md[gapBpValues.md], (gapBpValues === null || gapBpValues === void 0 ? void 0 : gapBpValues.lg) && classes$1.lg[gapBpValues.lg], (gapBpValues === null || gapBpValues === void 0 ? void 0 : gapBpValues.xl) && classes$1.xl[gapBpValues.xl]];
}

const Grid = _ref => {
  let {
    as = "div",
    children,
    columns,
    gap = 1
  } = _ref;
  const GridHtmlElement = as;
  return /*#__PURE__*/React.createElement(GridHtmlElement, {
    "data-testid": "grid",
    className: classnames("grid", getColumnClasses(columns), gap && getGapClasses(gap))
  }, children);
};

const HEADING_SIZE_CLASSES = {
  1: "fs-0",
  2: "fs-21",
  3: "fs-2",
  4: "fs-3",
  5: "fs-4",
  6: "fs-5" // 12px
};
const getColorClasses$1 = color => `c-${color}`;
const getFontSizeClasses = (level, size) => HEADING_SIZE_CLASSES[size || level];
const Heading = _ref => {
  let {
    color = "tint0",
    isUppercase = false,
    level,
    size = undefined,
    text
  } = _ref;
  const HeadingTag = `h${level}`;
  return /*#__PURE__*/React.createElement(HeadingTag, {
    className: classnames("lh-1.333", getColorClasses$1(color), getFontSizeClasses(level, size), isUppercase && "tt-u", "fw-600")
  }, text);
};

const classes = {
  base: ["", "rounded"],
  xs: ["xs:rounded-none", "xs:rounded"],
  sm: ["sm:rounded-none", "sm:rounded"],
  md: ["md:rounded-none", "md:rounded"],
  lg: ["lg:rounded-none", "lg:rounded"],
  xl: ["xl:rounded-none", "xl:rounded"]
};
function getRoundedClasses(rounded) {
  const hasRoundedBreakpoints = Array.isArray(rounded);
  const baseRoundedValue = hasRoundedBreakpoints ? rounded[0] : rounded;
  const roundedBpValues = hasRoundedBreakpoints ? rounded[1] : undefined;
  return [baseRoundedValue && classes.base[baseRoundedValue ? 1 : 0], (roundedBpValues === null || roundedBpValues === void 0 ? void 0 : roundedBpValues.xs) !== undefined && classes.xs[roundedBpValues.xs ? 1 : 0], (roundedBpValues === null || roundedBpValues === void 0 ? void 0 : roundedBpValues.sm) !== undefined && classes.sm[roundedBpValues.sm ? 1 : 0], (roundedBpValues === null || roundedBpValues === void 0 ? void 0 : roundedBpValues.md) !== undefined && classes.md[roundedBpValues.md ? 1 : 0], (roundedBpValues === null || roundedBpValues === void 0 ? void 0 : roundedBpValues.lg) !== undefined && classes.lg[roundedBpValues.lg ? 1 : 0], (roundedBpValues === null || roundedBpValues === void 0 ? void 0 : roundedBpValues.xl) !== undefined && classes.xl[roundedBpValues.xl ? 1 : 0]];
}

const Image = _ref => {
  let {
    aspectRatio = "auto",
    alt,
    rounded = false,
    src
  } = _ref;
  return /*#__PURE__*/React.createElement("img", {
    alt: alt,
    className: classnames("block", "w-full", rounded && getRoundedClasses(rounded)),
    src: src,
    style: {
      aspectRatio: aspectRatio
    }
  });
};

const useOutsideClick = callback => {
  const ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [callback]);
  return ref;
};

const detectDeviceType = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? "mobile" : "desktop";
const isMobileBroswer = detectDeviceType() === "mobile";
const isDesktopBrowser = detectDeviceType() === "desktop";

const NumberSpinner = _ref => {
  let {
    disabled = false,
    max,
    min = 0,
    name = "number-spinner",
    onChange,
    size = "md",
    value: originalValue
  } = _ref;
  const [focus, setFocus] = useState(false);
  const handleKeyDown = e => {
    if (e.key === "ArrowUp" || e.key === "ArrowRight") handleIncrement();
    if (e.key === "ArrowDown" || e.key === "ArrowLeft") handleDecrement();
  };
  const clampValue = newValue => {
    if (newValue > max) return max;
    if (newValue < min) return min;
    return newValue;
  };
  let value = clampValue(originalValue);
  const handleDecrement = () => onChange(clampValue(value - 1));
  const handleIncrement = () => onChange(clampValue(value + 1));
  const handleClickOutside = useOutsideClick(() => {
    focus && setFocus(false);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("number-spinner", {
      "sm-number-spinner": size === "sm",
      focused: isDesktopBrowser && focus
    }),
    "data-testid": "numberSpinner",
    ref: handleClickOutside
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "decrease quantity",
    className: "number-spinner__btn number-spinner__btn-decrement",
    disabled: disabled || value === min,
    onBlur: () => setFocus(false),
    onClick: handleDecrement,
    onFocus: () => setFocus(true),
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("span", null, "-")), /*#__PURE__*/React.createElement("input", {
    "aria-label": "quantity",
    className: "number-spinner__input",
    disabled: disabled,
    max: max,
    min: min,
    name: name,
    onBlur: () => setFocus(false),
    onChange: () => {},
    onFocus: () => setFocus(true),
    onKeyDown: handleKeyDown,
    onWheel: e => e.target.blur(),
    readOnly: isMobileBroswer,
    step: "1",
    type: "number",
    value: Number(value).toString()
  }), /*#__PURE__*/React.createElement("button", {
    "aria-label": "increase quantity",
    className: "number-spinner__btn number-spinner__btn-increment",
    disabled: disabled || value === max,
    onBlur: () => setFocus(false),
    onClick: handleIncrement,
    onFocus: () => setFocus(true),
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("span", null, "+")));
};

const Option = _ref => {
  let {
    disabled = false,
    hidden = false,
    label,
    value
  } = _ref;
  return /*#__PURE__*/React.createElement("option", {
    key: label,
    disabled: disabled,
    hidden: hidden,
    value: value
  }, label);
};
Option.displayName = "Select.Option";

const OptGroup = _ref => {
  let {
    children,
    disabled = false,
    label
  } = _ref;
  return /*#__PURE__*/React.createElement("optgroup", {
    label: label,
    disabled: disabled
  }, children);
};
OptGroup.displayName = "Select.OptGroup";

const Select = _ref => {
  let {
    ariaLabel = undefined,
    children,
    disabled = false,
    id,
    label = "",
    name = undefined,
    onBlur = undefined,
    onChange,
    required = false,
    size = "md",
    value
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, label && ( /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label, required ? /*#__PURE__*/React.createElement("span", {
    className: "c-ruby ml-4p"
  }, "*") : null)), /*#__PURE__*/React.createElement("select", {
    "aria-label": ariaLabel,
    className: classnames("select", `${size}-select`),
    disabled: disabled,
    id: id,
    name: name,
    onBlur: e => onBlur && onBlur(e),
    onChange: e => onChange(e),
    required: required,
    value: value
  }, children));
};
Select.Option = Option;
Select.OptGroup = OptGroup;

const getColorClasses = color => `c-${color}`;
const Subheading = _ref => {
  let {
    color = "tint1",
    level,
    text
  } = _ref;
  const SubheadingTag = `h${level}`;
  return /*#__PURE__*/React.createElement(SubheadingTag, {
    className: classnames("fs-4 fw-600 lh-20p tt-u", getColorClasses(color))
  }, text);
};

const Textarea = _ref => {
  let {
    disabled = false,
    id,
    label = "",
    name,
    onChange = undefined,
    placeholder = "",
    rows = 2,
    value = ""
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label), /*#__PURE__*/React.createElement("textarea", {
    disabled: disabled,
    id: id,
    name: name,
    onChange: e => typeof onChange === "function" && onChange(e),
    placeholder: placeholder,
    rows: rows,
    value: value
  }));
};

const TextInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    autoComplete = "on",
    disabled = false,
    id,
    label = "",
    name = "",
    onChange,
    placeholder = "",
    readOnly = undefined,
    required = false,
    size = "md",
    value
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, label && ( /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label, required && /*#__PURE__*/React.createElement("span", {
    className: "c-ruby"
  }, " *"))), /*#__PURE__*/React.createElement("input", {
    className: classnames("text-input", size == "sm" && "sm-input", readOnly && "pe-n"),
    autoComplete: autoComplete,
    disabled: disabled,
    id: id,
    name: name || id,
    onChange: e => typeof onChange === "function" && onChange(e),
    placeholder: placeholder,
    ref: ref,
    readOnly: readOnly,
    required: required,
    type: "text",
    value: value
  }));
});

export { Alert, Badge, Button, Checkbox, Grid, Heading, Image, NumberSpinner, Select, Subheading, TextInput, Textarea };
//# sourceMappingURL=index.es.js.map
